import { Box, keyframes } from "@mui/material";

export interface RuleGraphEdgeFill {
  color: string;
  durationMs: number;
}

const railFill = keyframes`
  from { stroke-dashoffset: 1; }
  to { stroke-dashoffset: 0; }
`;

export const RuleGraphEdgeFillPath = ({
  path,
  fill,
}: {
  path: string;
  fill: RuleGraphEdgeFill;
}) => (
  <Box
    component="path"
    d={path}
    data-testid="rule-graph-edge-fill"
    fill="none"
    pathLength={1}
    stroke={fill.color}
    strokeDasharray="1 1"
    strokeWidth={1.5}
    sx={{
      animation: `${railFill} ${fill.durationMs}ms linear forwards`,
      pointerEvents: "none",
      "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        strokeDashoffset: 0,
      },
    }}
  />
);
